import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { PropsFromRedux } from '.';
import classBanner from '../../assets/images/walletpin.svg';


interface Props extends PropsFromRedux {}

const WalletPinModal: React.FC<Props> = ({ hideModal, showModal, modal }) => {

  const showPinSetup = () => {
    hideModal();
    showModal({
      component: 'WalletPinSetup',
      modalProps: {
        contentLabel: 'Wallet Pin Setup',
      },
    });
  }

  const closeModal = () => {
    hideModal();
  };
  
  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return(
    <div className="w-full px-4 bg-white lg:px-14 py-10 relative overflow-hidden  ">
        <button type="button" aria-label="Close" onClick={closeModal}>
        <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
    <div className="w-full my-2 flex items-center justify-center ">
      <img src={classBanner} alt="GIG App" className="w-20 my-4" />
    </div>
     <div className="w-full my-2 text-center">
         <h2 className="mb-1 text-2xl font-bold text-black">Create Wallet Pin</h2>
      </div>
      <div className="w-full max-w-md mx-auto text-center mb-10 text-sm text-justify">
      <p className="text-gray-500 my-4">
         Hi there, we are introducing a wallet pin feature for additional security on your
         GIGGo wallet.
       </p>
       <p className="text-gray-500">
         You will now confirm all transactions on the app using your desired pin.
         Kindly set up your wallet pin to access this feature.
       </p>
      </div>
      <button className="w-full bg-secondary font-medium text-sm rounded text-white py-4" type="button" onClick={() => showPinSetup()}>Set Up Wallet Pin</button>

  </div>
  );
  // </ModalWrapper>
};

export default WalletPinModal;
